export default [
    {
        path: "vehicles",
        name: "settings-vehicles",
        redirect: { name: "settings-vehicles-list" },
        component: () => import("@/views/commons/vehicles/Vehicles.vue"),
        meta: {
            section: 30,
            pageTitle: "Vehicles",
            breadcrumb: [
                {
                    text: "List",
                    active: true,
                },
            ],
        },

        children: [
            {
                path: "list",
                name: "settings-vehicles-list",
                component: () => import("@/views/commons/vehicles/components/VehiclesTable.vue"),
                meta: {
                    section: 30,
                    pageTitle: "Vehicles",
                    breadcrumb: [
                        {
                            text: "List",
                            active: true,
                        },
                    ],
                },
            },             
        ],
    },
];